"use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    var notification = document.createElement("div");
    notification.classList.add("notification", type);
    notification.style.top = "".concat(posTop, "px");
    notification.style.right = "".concat(posRight, "px");
    var titleElement = document.createElement("h2");
    titleElement.className = "title";
    titleElement.textContent = title;
    notification.appendChild(titleElement);
    var descriptionElement = document.createElement("p");
    descriptionElement.textContent = description;
    notification.appendChild(descriptionElement);
    document.body.appendChild(notification);
    setTimeout(function() {
        notification.style.display = "none";
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(165, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.146a9149.js.map
